import { useMemo } from 'react';
import { object, string, ObjectSchema } from 'yup';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { CSV_SAFE_REGEX } from '@cbridge-utils/shared-helpers';
import { nodeNamesSelector } from '../_selectors/nodeNames.selector';
import { NODE_NAME_MIN_LENGTH, NODE_NAME_MAX_LENGTH } from '../node.constant';
import { INodeForm } from '../node.interface';

export const useCreateNodeFormSchema = (): ObjectSchema<INodeForm> => {
  const nodeNames = useSelector(nodeNamesSelector);
  const { t } = useTranslation();

  return useMemo(() => {
    return object<INodeForm>().shape({
      name: string()
        .trim()
        .label(t('text:entity.symbolPool.nodeName.label'))
        .min(NODE_NAME_MIN_LENGTH)
        .max(NODE_NAME_MAX_LENGTH)
        .matches(CSV_SAFE_REGEX, t('text:validation.chars.csvUnsafe'))
        .required()
        .test('unique', 'Name of Node must be unique', (value) => {
          if (!value) return true;
          return !nodeNames.has(value);
        }),
    });
  }, [t, nodeNames]);
};
